<template>
	<div
		class="relative mt-xs w-full sm:block"
		:class="{
			hidden: hideOnMobile,
		}"
	>
		<div
			class="flex flex-col gap-x-xs lg:grid lg:grid-cols-4 lg:gap-x-sm lg:gap-y-xl"
		>
			<!-- Two slightly different versions here -->
			<client-only>
				<v-category-filter-facet
					v-for="facet in primaryFacets"
					:key="facet?.id"
					v-model="selectedFacets[facet?.id]"
					class="hidden lg:block"
					:facet="facet"
					always-show
				/>

				<v-category-filter-facet
					v-for="facet in primaryFacets"
					:key="facet?.id"
					v-model="selectedFacets[facet?.id]"
					class="block lg:hidden"
					:facet="facet"
					size="sm"
					expand-type="chevron"
					has-border
				/>

				<template #fallback>
					<div class="h-[85px]" />
				</template>
			</client-only>
		</div>
	</div>
</template>

<script setup lang="ts">
import type {Facet} from "@apptus/esales-api";
import type {Ref} from "vue";
import {primaryProductFacets} from "@pkg/shared/constants/searching";

withDefaults(
	defineProps<{
		// We may want to hide this on mobile in some cases
		hideOnMobile?: boolean;
	}>(),
	{
		hideOnMobile: false,
	},
);

const facets = inject<Ref<Facet[]>>("facets", ref([]));
const selectedFacets = inject<
	Ref<Record<string, (string | number | boolean)[]>>
>("activeFilters", ref({}));

const primaryFacets = computed(() => {
	if (!facets.value) return [];

	return facets.value.filter((x) => primaryProductFacets.includes(x.id));
});
</script>

<style scoped></style>
